import {
  greyColor, maxMobile, primaryColor, primaryFont, primaryHeadingColor, wMedium,
} from 'Utils/utilsStyle';
import { Timeline } from 'antd';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  .ant-timeline {
    margin-left: 18px;
    @media all and (max-width: ${maxMobile}){
      margin-left: 15px;
    }
  }
  .ant-timeline-item-content {
    margin-left: 42px;
    top: -2px;
    @media all and (max-width: ${maxMobile}){
      margin-left: 35px;
    }
  }
  .ant-timeline-item-head {
    background-color: ${greyColor};
    @media all and (max-width: ${maxMobile}){
      width: 7px;
      height: 7px;
      left: 1px;
    }
  }
  .title-timeline {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 16px; /* 114.286% */
    display: block;
    @media all and (max-width: ${maxMobile}){
      font-size: 12px;
      line-height: 14px;
    }
  }
  .date-timeline {
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 16px;
    display: block;
    margin: 3px 0px;
    @media all and (max-width: ${maxMobile}){
      font-size: 12px;
      line-height: 14px;
    }
  }
  .description-timeline {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 16px;
    display: block;
    white-space: break-spaces;
    @media all and (max-width: ${maxMobile}){
      font-size: 12px;
      line-height: 14px;
    }
  }
`;

type Props = {
  children: ReactNode,
};

const CareerTimeLine = function CareerTimeLine(props: Props) {
  const {
    children,
  } = props;
  return (
    <Wrapper className="career-widget">
      <Timeline>
        {children}
      </Timeline>
    </Wrapper>
  );
};

export default CareerTimeLine;
